import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "../../../examples/Tables/DataTable";
import data from "../../dashboard/components/Projects/data";
import useApi from "../../../components/Utils/api";
import toast from "react-hot-toast";
import { DateRangePicker } from "rsuite";
import { afterToday } from "rsuite/cjs/DateRangePicker/disabledDateUtils";
import reportsLineChartData from "../../dashboard/data/reportsLineChartData";
import Papa from 'papaparse';

function CardSettlementSummary() {
  const { cardSettlementSummaryTableColumns } = data();
  const { predefinedRanges } = reportsLineChartData;
  const [summary, setSummary] = useState([]);

  const getTodayDateAtMidnight = () => {
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    return now;
  };

  const [lastMonthDateRange, setLastMonthDateRange] = useState([
    getTodayDateAtMidnight(),
    getTodayDateAtMidnight()
  ]);

  const api = useApi();

  // Adjusted formatDate function to handle UTC correctly
  const formatDate = (date) => {
    const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    return utcDate.toISOString().slice(0, 10); // Format as YYYY-MM-DD
  };

  const getCardSettlementSummary = (dateRange) => {
    if (dateRange == null) return;

    const data = {
      fromDate: formatDate(dateRange[0]),
      toDate: formatDate(dateRange[1]),
    };

    console.log('API Call Data:', data); // Log the data being sent to the API for debugging

    api.post("reports/cardSettlementsummary", data)
      .then((response) => {
        if (response.data.statusCodeValue === 200) {
          setSummary(response.data.body);
        } else {
          setSummary(null);
          const toastId = toast.error("No Record Found", { autoClose: false });
          setTimeout(() => toast.dismiss(toastId), 1000);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          toast.error("You do not have permission to perform this action.");
        }
      });
  };

  const handleDateRangeChange = (date) => {
    if (date && date.length === 2) {
      setLastMonthDateRange(date.map(d => new Date(d))); // Ensure we're storing Date objects
    }
  };

  const generateCSV = () => {
    if (!summary || summary.length === 0) {
      return '';
    }
  
    const headers = cardSettlementSummaryTableColumns
      .map(column => column.Header)
      .filter((header, index) => index !== 0 && header !== 'Action' && header !== 'Settlement Allowed');
  
    const summaryWithUppercaseColumns = summary.map(item => {
      return cardSettlementSummaryTableColumns
        .filter((column, index) => index !== 0 && column.Header !== 'Action' && column.Header !== 'Settlement Allowed')
        .map(column => {
          const accessor = column.accessor;
          const value = typeof accessor === 'function' ? accessor(item) : item[accessor];
          return value;
        });
    });
  
    const csvData = [headers, ...summaryWithUppercaseColumns];
    return Papa.unparse(csvData, { quotes: true });
  };
  
  const handleDownloadCSV = () => {
    if (!summary || summary.length === 0) {
      const toastId = toast.error("No records found to download", { autoClose: false });
      setTimeout(() => toast.dismiss(toastId), 1000);
      return;
    }
  
    const csvData = generateCSV();
    const currentDate = new Date().toISOString().slice(0, 10);
    const currentTime = new Date().toLocaleTimeString().replace(/:/g, '-');
    const dateTimeString = `${currentDate}_${currentTime}`;
    const fileName = `CardSettlementSummary_${dateTimeString}.csv`;
  
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  
  useEffect(() => {
    if (lastMonthDateRange && lastMonthDateRange.length === 2) {
      getCardSettlementSummary(lastMonthDateRange);
    }
  }, [lastMonthDateRange]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={12}>
            <Grid item xs={12} md={12} lg={12}>
              <MDBox mb={3} textAlign={"center"}>
                <DateRangePicker
                  disabledDate={afterToday()}
                  ranges={predefinedRanges}
                  onChange={handleDateRangeChange}
                  format="yyyy-MM-dd"
                  value={
                    lastMonthDateRange.length
                      ? [new Date(lastMonthDateRange[0]), new Date(lastMonthDateRange[1])]
                      : []
                  }
                />
              </MDBox>
            </Grid>
            <MDButton
              variant="gradient"
              onClick={handleDownloadCSV}
              color="info"
              style={{ marginRight: "24px", marginBottom: "12px" }}
            >
              Export
            </MDButton>
            <DataTable
              table={{ columns: cardSettlementSummaryTableColumns, rows: summary }}
              showTotalEntries={true}
              isSorted={true}
              noEndBorder
              entriesPerPage={true}
              canSearch={true}
            />
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CardSettlementSummary;
